import "core-js/stable";
import "regenerator-runtime/runtime";

import "./css/site.css";
import { createApp } from "vue";
import App from "./App.vue";
import HeaderApp from "./HeaderApp.vue";
import router from "./router/router";
import appFilters from "./func/appFilters";
import { siteUser, userLoadStatus } from "./state/appState";

// TODO remove legacy support when possible
const mountEl = document.querySelector("#header-vue-app") as any;
const loginApp = createApp(HeaderApp, { ...mountEl?.dataset });
loginApp.config.globalProperties.$currentUser = siteUser;
loginApp.config.globalProperties.$userLoadStatus = userLoadStatus;
loginApp.use(router).mount("#header-vue-app");

const app = createApp(App);
app.config.globalProperties.$filters = appFilters;
app.config.globalProperties.$currentUser = siteUser;
app.config.globalProperties.$userLoadStatus = userLoadStatus;
app.use(router).mount("#main-vue-app");

__webpack_public_path__ =
  process.env.NODE_ENV == "production" ? "/site2/" : "/site2dev/";
